import { analyticsAxiosConfig } from "../../../config/axios.config"
import { Intervals } from "../../../types/dashboard-chart-types"

export async function getEndpointTraffic(body: {
	token: string
	interval: Intervals
	host: string
}) {
	const response = await analyticsAxiosConfig.get(
		`/analytics/traffic/requests_by_route?interval=${body.interval}&host=${body.host}`,
		{
			headers: {
				Authorization: `Bearer ${body.token}`,
			},
		}
	)
	const { data } = response
	return data
}
